const VAPID_PUBLIC_KEY = 'BF-fDuaJD4OQSK12u_33R0mPrlAhiP9guGeOXs-KCk4wZDJATQYLjCTQPUlCkww8JrYhtCIwteCb9-SuupWnnW4';
const CSRF_TOKEN = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/build/sw.js', {scope: '/'});
    })
}

window.requestNotificationAndEnablePush = function () {
    navigator.serviceWorker.ready.then(registration => {
        registration.pushManager.getSubscription().then(subscription => {
            if (!subscription) {
                Notification.requestPermission().then(permission => {
                    if (permission === 'granted') {
                        pushEnable();
                    }
                })
            }
        });
    });
}

window.pushEnable = async function () {
    navigator.serviceWorker.ready.then(registration => {
        registration.pushManager.getSubscription().then(subscription => {
            if (subscription) {
                return subscription;
            }

            return registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
            });
        }).then(subscription => {
            if (subscription !== null) {
                pushSubscribe(subscription);
            } else {
                Toaster.error('Unable to enable push notifications.')
            }
        });
    });
}

window.pushDisable = async function () {
    navigator.serviceWorker.ready.then(registration => {
        registration.pushManager.getSubscription().then(subscription => {
            if (!subscription) {
                return;
            }

            subscription.unsubscribe().then(() => {
                fetch('/notification/push/unsubscribe', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': CSRF_TOKEN,
                    },
                    body: JSON.stringify({
                        endpoint: subscription.endpoint
                    })
                })
                    .then(response => response.json())
                    .then(() => {
                        Toaster.warning('Push notifications disabled.')
                    })
                    .catch((error) => {
                        Toaster.error('An error occurred while disabling push notifications.');
                        console.error('Push Error: ', error);
                    });
            });
        });
    });
}

async function pushSubscribe(subscription) {
    const key = subscription.getKey('p256dh');
    const token = subscription.getKey('auth');
    const contentEncoding = (PushManager.supportedContentEncodings || ['aesgcm'])[0];

    const data = {
        endpoint: subscription.endpoint,
        public_key: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
        auth_token: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
        encoding: contentEncoding,
    };

    fetch('/notification/push/subscribe', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': CSRF_TOKEN,
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .then(() => {
            Toaster.success('Push notification enabled.')
        })
        .catch((error) => {
            Toaster.error('Unable to enable push notifications.')
            console.error('Push Error: ', error);
        });
}

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
}
